'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var key = require('interface-datastore/key');

var debug = require('debug');

var length = require('it-length');

var base32 = require('multiformats/bases/base32');

var raw = require('multiformats/codecs/raw');

var mhd = require('multiformats/hashes/digest');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n['default'] = e;
  return Object.freeze(n);
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var length__default = /*#__PURE__*/_interopDefaultLegacy(length);

var raw__namespace = /*#__PURE__*/_interopNamespace(raw);

var mhd__namespace = /*#__PURE__*/_interopNamespace(mhd);

var log = debug__default['default']('ipfs:repo:migrator:migration-8');

function unwrap(blockstore) {
  if (blockstore.child) {
    return unwrap(blockstore.child);
  }

  return blockstore;
}

function keyToMultihash(key$1) {
  try {
    var buf = base32.base32.decode("b".concat(key$1.toString().toLowerCase().slice(1)));
    var multihash = cid.CID.decode(buf).multihash.bytes;
    var multihashStr = base32.base32.encode(multihash).slice(1).toUpperCase();
    return new key.Key("/".concat(multihashStr), false);
  } catch (err) {
    return key$1;
  }
}

function keyToCid(key$1) {
  try {
    var buf = base32.base32.decode("b".concat(key$1.toString().toLowerCase().slice(1)));
    var digest = mhd__namespace.decode(buf);
    var multihash = base32.base32.encode(cid.CID.createV1(raw__namespace.code, digest).bytes).slice(1);
    return new key.Key("/".concat(multihash.toUpperCase()), false);
  } catch (_unused) {
    return key$1;
  }
}

function process(_x, _x2, _x3) {
  return _process.apply(this, arguments);
}

function _process() {
  _process = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(backends, onProgress, keyFunction) {
    var blockstore, unwrapped, blockCount, counter, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, block, newKey;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            blockstore = backends.blocks;
            _context.next = 3;
            return blockstore.open();

          case 3:
            unwrapped = unwrap(blockstore);
            _context.next = 6;
            return length__default['default'](unwrapped.queryKeys({
              filters: [function (key) {
                var newKey = keyFunction(key);
                return newKey.toString() !== key.toString();
              }]
            }));

          case 6:
            blockCount = _context.sent;
            _context.prev = 7;
            counter = 0;
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 11;
            _iterator = _asyncIterator(unwrapped.query({}));

          case 13:
            _context.next = 15;
            return _iterator.next();

          case 15:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 34;
              break;
            }

            block = _step.value;
            newKey = keyFunction(block.key);

            if (!(newKey.toString() !== block.key.toString())) {
              _context.next = 31;
              break;
            }

            counter += 1;
            _context.t0 = log;
            _context.t1 = "Migrating Block from ".concat(block.key, " to ").concat(newKey);
            _context.next = 24;
            return unwrapped.has(block.key);

          case 24:
            _context.t2 = _context.sent;
            (0, _context.t0)(_context.t1, _context.t2);
            _context.next = 28;
            return unwrapped.delete(block.key);

          case 28:
            _context.next = 30;
            return unwrapped.put(newKey, block.value);

          case 30:
            onProgress(counter / blockCount * 100, "Migrated Block from ".concat(block.key, " to ").concat(newKey));

          case 31:
            _iteratorAbruptCompletion = false;
            _context.next = 13;
            break;

          case 34:
            _context.next = 40;
            break;

          case 36:
            _context.prev = 36;
            _context.t3 = _context["catch"](11);
            _didIteratorError = true;
            _iteratorError = _context.t3;

          case 40:
            _context.prev = 40;
            _context.prev = 41;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 45;
              break;
            }

            _context.next = 45;
            return _iterator.return();

          case 45:
            _context.prev = 45;

            if (!_didIteratorError) {
              _context.next = 48;
              break;
            }

            throw _iteratorError;

          case 48:
            return _context.finish(45);

          case 49:
            return _context.finish(40);

          case 50:
            _context.prev = 50;
            _context.next = 53;
            return blockstore.close();

          case 53:
            return _context.finish(50);

          case 54:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7,, 50, 54], [11, 36, 40, 50], [41,, 45, 49]]);
  }));
  return _process.apply(this, arguments);
}

var migration = {
  version: 8,
  description: 'Transforms key names into base32 encoding and converts Block store to use bare multihashes encoded as base32',
  migrate: function migrate(backends) {
    var onProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    return process(backends, onProgress, keyToMultihash);
  },
  revert: function revert(backends) {
    var onProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    return process(backends, onProgress, keyToCid);
  }
};
exports.migration = migration;